module.exports = __webpack_public_path__ + "static/media/breedon.5339790b.png";